import React, { useEffect, useState } from 'react';
import PhotoCaptureContainer from './PhotoCaptureContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';
import {
  withMobileAppMode,
  UploadImageConnectorApollo,
  useToast,
} from '@front-activerse/common-components';
import { Spinner } from 'reactstrap';

const PhotoCapturePage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toastError } = useToast();
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setIsUploading(false);
  }, [location.key]);

  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess !== 'true' && !mobileAppMode) {
    return <TrackerNoAccess />;
  }

  return (
    <UploadImageConnectorApollo>
      {({ uploadImage }) => {
        const handlePhotoTaken = async (file: File) => {
          setIsUploading(true);
          try {
            const result = (await uploadImage(file, 'activity')) as {
              __typename: string;
              imageUrl?: string;
            };

            if (result?.__typename === 'UploadImageSuccess' && result.imageUrl) {
              window.dispatchEvent(
                new CustomEvent('activityPhotoUploaded', { detail: { imageUrl: result.imageUrl } })
              );
              navigate(-1);
              // Dispatch again after navigation for components that remount (add mode)
              setTimeout(() => {
                window.dispatchEvent(
                  new CustomEvent('activityPhotoUploaded', {
                    detail: { imageUrl: result.imageUrl },
                  })
                );
              }, 100);
            } else {
              toastError();
              setIsUploading(false);
            }
          } catch {
            toastError();
            setIsUploading(false);
          }
        };

        if (isUploading) {
          return (
            <div className="d-flex justify-content-center align-items-center vh-100">
              <Spinner />
            </div>
          );
        }

        return <PhotoCaptureContainer key={location.key} onPhotoTaken={handlePhotoTaken} />;
      }}
    </UploadImageConnectorApollo>
  );
};

export default withMobileAppMode(PhotoCapturePage);
